/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  UpdateSurrogateInfoErrorResponse,
  UpdateSurrogateInfoRequest,
  UpdateSurrogateInfoResponse,
} from './api.schemas';

import { api } from '../util/http';

export const updatePatientSurrogate = (
  patientId: string,
  updateSurrogateInfoRequest: UpdateSurrogateInfoRequest,
) => {
  return api<UpdateSurrogateInfoResponse>({
    url: `/api/patient/${patientId}/surrogate`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateSurrogateInfoRequest,
  });
};

export const getUpdatePatientSurrogateMutationOptions = <
  TError = UpdateSurrogateInfoErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePatientSurrogate>>,
    TError,
    { patientId: string; data: UpdateSurrogateInfoRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePatientSurrogate>>,
  TError,
  { patientId: string; data: UpdateSurrogateInfoRequest },
  TContext
> => {
  const mutationKey = ['updatePatientSurrogate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePatientSurrogate>>,
    { patientId: string; data: UpdateSurrogateInfoRequest }
  > = (props) => {
    const { patientId, data } = props ?? {};

    return updatePatientSurrogate(patientId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePatientSurrogateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePatientSurrogate>>
>;
export type UpdatePatientSurrogateMutationBody = UpdateSurrogateInfoRequest;
export type UpdatePatientSurrogateMutationError = UpdateSurrogateInfoErrorResponse;

export const useUpdatePatientSurrogate = <
  TError = UpdateSurrogateInfoErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePatientSurrogate>>,
      TError,
      { patientId: string; data: UpdateSurrogateInfoRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePatientSurrogate>>,
  TError,
  { patientId: string; data: UpdateSurrogateInfoRequest },
  TContext
> => {
  const mutationOptions = getUpdatePatientSurrogateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
